import { buildCommonFilters, embedFilter, labeledMapItem } from '../sharedFilters'

const DATASET_KEY = 'hanwha_cameras'

// This is an inventory dataset (the camera catalog), and its declared time
// filter is unusable: $time_filter rides cameras_proxy.updated_at, but the
// join it needs (hanwha_dvrs.id_camera_proxy = cameras_proxy.id AND
// camera_type = 'App\Models\HanwhaCamera') can never match: that FK is the
// proxy of the DVR's *router* (App\Models\AdditionalRouter), so the type
// condition fails and cameras_proxy.id is null on every row (measured on
// staging and Banamex staging). ANY from/to therefore returns 0 rows while
// the same query without a time range returns the whole catalog. The module
// therefore declares omitTimeRange (URLs travel with no from/to and the date
// controls are hidden) and no timeColumn (the temporal placeholders would
// bucket everything under null). If the backend repoints the dataset's time
// filter at a real column, drop the flag and restore timeColumn/timeseries.
const commonFilters = buildCommonFilters(DATASET_KEY, {
  INSTALLATION: {},                              // units.description (via hanwha_dvrs.id_unit)
  REGION: {},                                    // regions.name
  MUNICIPALITY: {},                              // municipalities.name
  SECTOR: {},                                    // sectors.name (direct: hanwha_cameras.id_sector)
  CENTER: {},                                    // centers.name (direct: hanwha_cameras.id_center)
  TENANT: {},                                    // tenants.name (via hanwha_dvrs.id_tenant)
  STATUS: false,                                 // cameras_proxy.online rides the same dead join
  USER: false,                                   // no users join
})

const IS_FISHEYE_LABELS = { 0: 'No', 1: 'Sí' }
const IS_FISHEYE_MAPPING = JSON.stringify({
  'hanwha_cameras.is_fisheye': IS_FISHEYE_LABELS,
  is_fisheye: IS_FISHEYE_LABELS,
})

export default {
  key: DATASET_KEY,
  label: 'Cámaras Hanwha',
  permission: { action: 'read', subject: 'HanwhaCamera' },
  omitTimeRange: true,

  tables: {
    hanwha_cameras: ["id", "channel", "name", "type", "id_hanwha_dvr", "id_center", "id_sector", "id_type", "local_ip", "protocol", "model", "is_fisheye", "created_at", "updated_at"],
    hanwha_dvrs: ["id", "name", "id_tenant", "id_unit", "model", "online"],
    cameras_types: ["id", "type", "description"],
    units: ["id", "description", "id_region", "id_municipality"],
    regions: ["id", "name"],
    municipalities: ["id", "name"],
    sectors: ["id", "id_center", "name"],
    centers: ["id", "name"],
    tenants: ["id", "name"],
  },

  views: [
    { value: 'bar', label: 'Barras' },
    { value: 'dona', label: 'Dona' },
    { value: 'ring', label: 'Pastel' },
    { value: 'dataframe', label: 'Lista', adminOnly: true },
    { value: 'json', label: 'JSON', adminOnly: true },
  ],

  defaults: {
    field: 'cameras_types.type',
  },

  csvConfig: {
    columns: 'hanwha_cameras.name,hanwha_cameras.model,hanwha_cameras.local_ip,hanwha_cameras.is_fisheye,cameras_types.type,hanwha_dvrs.name,units.description,regions.name,municipalities.name,sectors.name,centers.name,tenants.name',
    qualifiedColumns: true,
  },

  viewDefaults: {
    csv: { limit: -1 },
    dataframe: { limit: -1 },
    json: { limit: -1 },
    bar: { stack: 'group' },
  },

  fields: [
    { key: 'cameras_types.type', label: 'Tipo' },
    { key: 'hanwha_cameras.model', label: 'Modelo' },
    { key: 'hanwha_cameras.is_fisheye', label: 'Fisheye', defaultParams: { mapping: IS_FISHEYE_MAPPING } },
    { key: 'hanwha_dvrs.name', label: 'Grabador' },
    { key: 'units.description', label: 'Inmueble' },
    { key: 'regions.name', label: 'Estado' },
    { key: 'municipalities.name', label: 'Municipio' },
    { key: 'sectors.name', label: 'Región' },
    { key: 'centers.name', label: 'Centro' },
    { key: 'tenants.name', label: 'Tenant' },
  ],

  filters: [
    ...commonFilters,
    embedFilter(DATASET_KEY, 'cameras_types.type', 'Tipo', 'type'),
    embedFilter(DATASET_KEY, 'hanwha_cameras.model', 'Modelo', 'model'),
    embedFilter(DATASET_KEY, 'hanwha_dvrs.name', 'Grabador', 'group'),
    embedFilter(DATASET_KEY, 'hanwha_cameras.is_fisheye', 'Fisheye', 'is_fisheye', {
      optionsOverrides: { mapItem: labeledMapItem(IS_FISHEYE_LABELS) },
    }),
  ],
}
